(function(){
  function initArcNews(){
    var viewport=document.getElementById('ArcNewsCarousel');
    if(!viewport||viewport.dataset.ready==='1') return;
    viewport.dataset.ready='1';

    var track=viewport.querySelector('.arc-news-track');
    var cards=[].slice.call(viewport.querySelectorAll('.arc-news-card'));
    var prev=document.querySelector('.arc-news-prev');
    var next=document.querySelector('.arc-news-next');
    var progress=document.querySelector('.arc-news-progress span');
    if(!track||!cards.length) return;

    var timer=null;
    var paused=false;
    var dragging=false,startX=0,startScroll=0;

    function gap(){
      var s=getComputedStyle(track);
      return parseFloat(s.gap)||20;
    }
    function step(){
      return cards[0].getBoundingClientRect().width+gap();
    }
    function maxScroll(){
      return Math.max(0,viewport.scrollWidth-viewport.clientWidth);
    }
    function updateProgress(){
      var max=maxScroll();
      var pct=max?Math.min(100,(viewport.scrollLeft/max)*100):100;
      if(progress) progress.style.width=pct+'%';
    }
    function go(dir){
      var amount=step()*dir;
      if(dir>0 && viewport.scrollLeft>=maxScroll()-step()/2){
        viewport.scrollTo({left:0,behavior:'smooth'});
      }else if(dir<0 && viewport.scrollLeft<=step()/2){
        viewport.scrollTo({left:maxScroll(),behavior:'smooth'});
      }else{
        viewport.scrollBy({left:amount,behavior:'smooth'});
      }
    }
    function start(){
      stop();
      timer=setInterval(function(){if(!paused&&!dragging)go(1);},4500);
    }
    function stop(){if(timer){clearInterval(timer);timer=null;}}

    prev&&prev.addEventListener('click',function(){go(-1);start();});
    next&&next.addEventListener('click',function(){go(1);start();});
    viewport.addEventListener('mouseenter',function(){paused=true;});
    viewport.addEventListener('mouseleave',function(){paused=false;});
    viewport.addEventListener('focusin',function(){paused=true;});
    viewport.addEventListener('focusout',function(){paused=false;});
    viewport.addEventListener('scroll',updateProgress,{passive:true});

    viewport.addEventListener('pointerdown',function(e){
      if(e.pointerType==='mouse'&&e.button!==0)return;
      dragging=true;paused=true;startX=e.clientX;startScroll=viewport.scrollLeft;
      viewport.classList.add('is-dragging');
      viewport.setPointerCapture&&viewport.setPointerCapture(e.pointerId);
    });
    viewport.addEventListener('pointermove',function(e){
      if(!dragging)return;
      viewport.scrollLeft=startScroll-(e.clientX-startX);
    });
    function endDrag(){
      if(!dragging)return;
      dragging=false;paused=false;viewport.classList.remove('is-dragging');
      var s=step();
      viewport.scrollTo({left:Math.round(viewport.scrollLeft/s)*s,behavior:'smooth'});
    }
    viewport.addEventListener('pointerup',endDrag);
    viewport.addEventListener('pointercancel',endDrag);

    updateProgress();
    start();
    window.addEventListener('resize',updateProgress);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initArcNews);
  else initArcNews();
})();